import src from "IMAGE";
export default { src, width: 193, height: 200, blurWidth: 0, blurHeight: 0};
